export default "__VITE_ASSET__CIpgVQPd__"